import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation } from '../../airport-interfaces';
import { TabViewModule } from 'primeng/primeng';
import { TabView } from 'primeng/primeng';
import { TabPanel } from 'primeng/primeng';

import { AirportService } from '../../airport.service';
import { IScenario, ScenarioService } from '../../../scenario-activities/scenario.service';

import { UserSession } from '../../../shared/user-session';
import { UserInfoService } from '../../../shared/user-info.service';

import { Button } from 'primeng/primeng';
import * as _ from 'lodash';

import { OperationsGraphSelectionsComponent } from './operations-graph-selections.component';


@Component({
    template: require('./operations-graph.component.html'),
     styles: [require('../../../styles/faa_styles.css'),require('../../../styles/print_faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, Button, TabView, TabPanel, OperationsGraphSelectionsComponent]
})

export class OperationsGraphComponent implements OnInit, OnDestroy{
    pageTitle: string;
    errorMessage: string;
    private sub: any;    

    currentScenario: IScenario;
    allScenarios: IScenario[];

    isScenarioOwner: boolean = false;

    tableName: string;
    allOperations: IOperation[];
    locId: string;
    airportName: string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService) {
    }


    ngOnInit(): void{
        this.sub = this.route.params.subscribe(
            params => {
                this.tableName = params['tableName'];
                this.locId = params['locId'];
                this.airportName = params['airportName'];
                
                this._airportService.getOperations()
                    .subscribe(
                        operations => this.allOperations = operations,
                        error => this.errorMessage = <any>error);
            }
        );

        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );

        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }

    onTabChange(event: any) {

        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-graph/${this.allOperations[event.index].tableName}`, params]);
    }

    backFacilityView(){
        this.router.navigate([`/airports/${this.locId}`]);
    }

    backDataSheet(){

        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-list/${this.tableName}`, params]);
    }
}



/** WEBPACK FOOTER **
 ** ./app/airports/Operations-lists/operations-graphs/operations-graph.component.ts
 **/